(function () {
  'use strict';

  function initRoot(root) {
    if (!root || root.getAttribute('data-bsw-ready')) return;
    root.setAttribute('data-bsw-ready', '1');

    // Keep grid video thumbs paused on the fragment frame
    root.querySelectorAll('video.babag-social-wall__media').forEach(function (video) {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      var pause = function () {
        try {
          video.pause();
        } catch (err) {}
      };
      video.addEventListener('play', pause);
      video.addEventListener('loadeddata', pause);
    });

    var cells = Array.prototype.slice.call(root.querySelectorAll('[data-bsw-cell]'));
    if (!cells.length) return;

    var items = cells
      .map(function (el) {
        return {
          el: el,
          type: el.getAttribute('data-bsw-type') || 'image',
          src: el.getAttribute('data-bsw-src') || '',
          poster: el.getAttribute('data-bsw-poster') || ''
        };
      })
      .filter(function (item) {
        return !!item.src;
      });

    if (!items.length) return;

    var lb = root.querySelector('[data-bsw-lb]');
    var mediaWrap = root.querySelector('[data-bsw-lb-media]');
    var closeBtn = root.querySelector('[data-bsw-lb-close]');
    var prevBtn = root.querySelector('[data-bsw-lb-prev]');
    var nextBtn = root.querySelector('[data-bsw-lb-next]');
    var current = 0;
    var activeVideo = null;
    var lockY = 0;

    if (lb.parentNode !== document.body) {
      document.body.appendChild(lb);
    }

    function lockScroll() {
      lockY = window.scrollY || window.pageYOffset || 0;
      document.documentElement.classList.add('babag-social-wall-lock');
      document.body.style.top = '-' + lockY + 'px';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    }

    function unlockScroll() {
      document.documentElement.classList.remove('babag-social-wall-lock');
      document.body.style.top = '';
      document.body.style.position = '';
      document.body.style.width = '';
      window.scrollTo(0, lockY);
    }

    function cellPoster(item) {
      if (item.poster) return item.poster;
      var media = item.el.querySelector('img.babag-social-wall__media');
      if (media && media.currentSrc) return media.currentSrc;
      return '';
    }

    function openAt(idx) {
      if (idx < 0 || idx >= items.length) return;
      current = idx;
      var item = items[idx];
      mediaWrap.innerHTML = '';
      activeVideo = null;
      lb.classList.add('is-open');
      lockScroll();

      if (item.type === 'video') {
        var vid = document.createElement('video');
        vid.className = 'babag-social-wall-lb__media';
        vid.controls = true;
        vid.playsInline = true;
        vid.setAttribute('playsinline', '');
        vid.preload = 'auto';
        var poster = cellPoster(item);
        if (poster) vid.poster = poster;
        vid.src = item.src;
        activeVideo = vid;
        mediaWrap.appendChild(vid);
        var playPromise = vid.play();
        if (playPromise && playPromise.catch) playPromise.catch(function () {});
      } else {
        var img = document.createElement('img');
        img.className = 'babag-social-wall-lb__media';
        img.src = item.src;
        img.alt = '';
        mediaWrap.appendChild(img);
      }
    }

    function closeLb() {
      if (activeVideo) {
        activeVideo.pause();
        activeVideo.removeAttribute('src');
        activeVideo.load();
        activeVideo = null;
      }
      lb.classList.remove('is-open');
      mediaWrap.innerHTML = '';
      unlockScroll();
    }

    function goNext() {
      openAt((current + 1) % items.length);
    }

    function goPrev() {
      openAt((current - 1 + items.length) % items.length);
    }

    cells.forEach(function (el) {
      el.addEventListener('click', function () {
        var src = el.getAttribute('data-bsw-src') || '';
        var idx = items.findIndex(function (item) {
          return item.el === el;
        });
        if (idx < 0 || !src) return;
        openAt(idx);
      });
    });

    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      closeLb();
    });
    prevBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      goPrev();
    });
    nextBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      goNext();
    });
    lb.addEventListener('click', function (e) {
      if (e.target === lb) closeLb();
    });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLb();
      if (e.key === 'ArrowRight') goNext();
      if (e.key === 'ArrowLeft') goPrev();
    });
  }

  function boot() {
    document.querySelectorAll('[data-babag-social-wall]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
